import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { ServerStateDto } from '../../dto/ServerStateDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiUpdateServerState = async (dto?: ServerStateDto) => {
  const params: IApiParams = {
    url: '/server-state/updateServerState.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
